module.exports = __webpack_public_path__ + "media/images/dashboards/anticholinergics-0f34af6269911ec638f43947f4d7c968.png";